import { isHr, isTeamLeader } from './userPermissions';

export function canUpdateAttendance(user) {
  if (!user) return false;
  return isTeamLeader(user) || isHr(user);
}

export function canUpdateAttendanceStatus(user) {
  return canUpdateAttendance(user);
}

export function canAccessAttendanceLogs(user) {
  if (!user) return false;
  return isTeamLeader(user) || isHr(user);
}
